import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=702993eb&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('702993eb')) {
      api.createRecord('702993eb', component.options)
    } else {
      api.reload('702993eb', component.options)
    }
    module.hot.accept("./FullScreenLayout.vue?vue&type=template&id=702993eb&", function () {
      api.rerender('702993eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/layout/FullScreenLayout.vue"
export default component.exports